import { SingleSkeletonLoader } from '../../../components/SingleSkeletonLoader';
import { IncludedSeatsDisplay } from '../../../components/merch-card/seats-display/IncludedSeatsDisplay';
import { useCurrencyCodeUnitToDisplay, useDisplayedCurrencyCode } from '../../../hooks/pricing/useCurrencyDetails';
import { isAvailableCurrencyCode } from '../../../utils/typeguards';
import { useQueryParamTerm } from '../../../utils/urls/appQueryParamUtils';
import { useAdditionalCoreSeatPrice, useIncludedSeats, useShowAdditionalSeatsPriceSubtext, useShowIncludedSeats } from './useSeatsDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
export const IncludedSeatsDisplayContainer = ({
  productApiName
}) => {
  // Term Props
  const {
    queryParamTerm
  } = useQueryParamTerm();

  // Currency Props
  const currencyCode = useDisplayedCurrencyCode();
  const currencyCodeUnit = useCurrencyCodeUnitToDisplay();

  // Seat Props
  const {
    includedCoreSeats,
    includedSalesSeats,
    includedServiceSeats,
    includedCommerceSeats,
    loading: productDetailsLoading
  } = useIncludedSeats({
    productApiName
  });
  const {
    showAdditionalSeatsPriceSubtext,
    loading: showAdditionalSeatsPriceSubtextLoading
  } = useShowAdditionalSeatsPriceSubtext({
    productApiName,
    activeTerm: queryParamTerm
  });
  const {
    additionalCoreSeatsPrice,
    loading: additionalCoreSeatsPriceLoading
  } = useAdditionalCoreSeatPrice({
    productApiName,
    activeTerm: queryParamTerm
  });
  const {
    showIncludedSeats,
    loading: showIncludedSeatsLoading
  } = useShowIncludedSeats({
    productApiName
  });
  const loading = productDetailsLoading || showIncludedSeatsLoading || additionalCoreSeatsPriceLoading || showAdditionalSeatsPriceSubtextLoading;
  const isValidCurrencyCode = isAvailableCurrencyCode(currencyCode);
  if (loading) {
    return /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 60
    });
  }
  if (!isValidCurrencyCode) {
    return null;
  }
  return /*#__PURE__*/_jsx(IncludedSeatsDisplay, {
    includedCoreSeats: includedCoreSeats !== null && includedCoreSeats !== void 0 ? includedCoreSeats : 0,
    includedSalesSeats: includedSalesSeats !== null && includedSalesSeats !== void 0 ? includedSalesSeats : 0,
    includedServiceSeats: includedServiceSeats !== null && includedServiceSeats !== void 0 ? includedServiceSeats : 0,
    includedCommerceSeats: includedCommerceSeats !== null && includedCommerceSeats !== void 0 ? includedCommerceSeats : 0,
    showIncludedSeats: showIncludedSeats,
    showAdditionalSeatsPriceSubtext: showAdditionalSeatsPriceSubtext,
    additionalCoreSeatsPrice: additionalCoreSeatsPrice,
    currencyCode: currencyCode,
    currencyCodeUnit: currencyCodeUnit
  });
};